export const clonePrices = [
  {
    resource: 'cpu_core',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Процессорное ядро vCPU (2,6 ГГц в Москве, 2,3 ГГц в Санкт-Петербурге)',
      en: 'vCPU (2,6 GHz in Moscow, 2,3 GHz in Saint-Petersburg)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'cpu_core',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Процессорное ядро vCPU (2,6 ГГц в Москве, 2,3 ГГц в Санкт-Петербурге)',
      en: 'vCPU (2,6 GHz in Moscow, 2,3 GHz in Saint-Petersburg)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'cpu_core',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Процессорное ядро vCPU (2,6 ГГц в Москве, 2,3 ГГц в Санкт-Петербурге)',
      en: 'vCPU (2,6 GHz in Moscow, 2,3 GHz in Saint-Petersburg)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'cpu_core',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Процессорное ядро vCPU (2,6 ГГц в Москве, 2,3 ГГц в Санкт-Петербурге)',
      en: 'vCPU (2,6 GHz in Moscow, 2,3 GHz in Saint-Petersburg)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'cpu_core',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Процессорное ядро vCPU (2,6 ГГц в Москве, 2,3 ГГц в Санкт-Петербурге)',
      en: 'vCPU (2,6 GHz in Moscow, 2,3 GHz in Saint-Petersburg)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'cpu_core',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Процессорное ядро vCPU (2,6 ГГц)',
      en: 'vCPU (2,6 GHz)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Edge-роутер Compact',
      en: 'Edge Gateway Compact'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Edge-роутер Compact',
      en: 'Edge Gateway Compact'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Edge-роутер Compact',
      en: 'Edge Gateway Compact'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Edge-роутер Compact',
      en: 'Edge Gateway Compact'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Edge-роутер Compact',
      en: 'Edge Gateway Compact'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Edge-роутер Compact',
      en: 'Edge Gateway Compact'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Edge-роутер Large',
      en: 'Edge Gateway Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Edge-роутер Large',
      en: 'Edge Gateway Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Edge-роутер Large',
      en: 'Edge Gateway Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Edge-роутер Large',
      en: 'Edge Gateway Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Edge-роутер Large',
      en: 'Edge Gateway Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Edge-роутер Large',
      en: 'Edge Gateway Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Edge-роутер Quad Large',
      en: 'Edge Gateway Quad Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Edge-роутер Quad Large',
      en: 'Edge Gateway Quad Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Edge-роутер Quad Large',
      en: 'Edge Gateway Quad Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Edge-роутер Quad Large',
      en: 'Edge Gateway Quad Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Edge-роутер Quad Large',
      en: 'Edge Gateway Quad Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Edge-роутер Quad Large',
      en: 'Edge Gateway Quad Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Edge-роутер X-Large',
      en: 'Edge Gateway X-Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Edge-роутер X-Large',
      en: 'Edge Gateway X-Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Edge-роутер X-Large',
      en: 'Edge Gateway X-Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Edge-роутер X-Large',
      en: 'Edge Gateway X-Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Edge-роутер X-Large',
      en: 'Edge Gateway X-Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Edge-роутер X-Large',
      en: 'Edge Gateway X-Large'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Изолированная сеть',
      en: 'Isolated network'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Изолированная сеть',
      en: 'Isolated network'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Изолированная сеть',
      en: 'Isolated network'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Изолированная сеть',
      en: 'Isolated network'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Изолированная сеть',
      en: 'Isolated network'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Изолированная сеть',
      en: 'Isolated network'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_24',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_24',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_24',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_24',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_24',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_24',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_25',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_25',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_25',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_25',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_25',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_25',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_26',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_26',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_26',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_26',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_26',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_26',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_27',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_27',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_27',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_27',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_27',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_27',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_28',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_28',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_28',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_28',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_28',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_28',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_29',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_29',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_29',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_29',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_29',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_29',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_32',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_32',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_32',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_32',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_32',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'protected_subnet_32',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vhdd',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Fast vHDD — 2000 IOPS, Silver пул, 1 ГБ',
      en: 'Fast vHDD — 2000 IOPS, Silver Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vhdd',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Fast vHDD — 2000 IOPS, Silver пул, 1 ГБ',
      en: 'Fast vHDD — 2000 IOPS, Silver Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vssd',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Fast vSSD — 25000 IOPS, Gold пул, 1 ГБ',
      en: 'Fast vSSD — 25000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vssd',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Fast vSSD — 25000 IOPS, Gold пул, 1 ГБ',
      en: 'Fast vSSD — 25000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vssd',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Fast vSSD — 25000 IOPS, Gold пул, 1 ГБ',
      en: 'Fast vSSD — 25000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vssd',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Fast vSSD — 25000 IOPS, Gold пул, 1 ГБ',
      en: 'Fast vSSD — 25000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s-213a-960',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: null,
      en: null
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vhdd',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'vHDD — 150 IOPS, Silver пул, 1 ГБ',
      en: 'vHDD — 150 IOPS, Silver Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vhdd',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'vHDD — 150 IOPS, Silver пул, 1 ГБ',
      en: 'vHDD — 150 IOPS, Silver Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vssd',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'vSSD — 5000 IOPS, Gold пул, 1 ГБ',
      en: 'vSSD — 5000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vssd',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'vSSD — 5000 IOPS, Gold пул, 1 ГБ',
      en: 'vSSD — 5000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vssd',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'vSSD — 5000 IOPS, Gold пул, 1 ГБ',
      en: 'vSSD — 5000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vssd',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'vSSD — 5000 IOPS, Gold пул, 1 ГБ',
      en: 'vSSD — 5000 IOPS, Gold Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Direct connected подсеть /24',
      en: 'Direct connected subnet /24'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Direct connected подсеть /24',
      en: 'Direct connected subnet /24'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Direct connected подсеть /24',
      en: 'Direct connected subnet /24'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Direct connected подсеть /24',
      en: 'Direct connected subnet /24'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Direct connected подсеть /24',
      en: 'Direct connected subnet /24'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Direct connected подсеть /24',
      en: 'Direct connected subnet /24'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Direct connected подсеть /25',
      en: 'Direct connected subnet /25'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Direct connected подсеть /25',
      en: 'Direct connected subnet /25'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Direct connected подсеть /25',
      en: 'Direct connected subnet /25'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Direct connected подсеть /25',
      en: 'Direct connected subnet /25'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Direct connected подсеть /25',
      en: 'Direct connected subnet /25'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Direct connected подсеть /25',
      en: 'Direct connected subnet /25'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Direct connected подсеть /26',
      en: 'Direct connected subnet /26'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Direct connected подсеть /26',
      en: 'Direct connected subnet /26'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Direct connected подсеть /26',
      en: 'Direct connected subnet /26'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Direct connected подсеть /26',
      en: 'Direct connected subnet /26'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Direct connected подсеть /26',
      en: 'Direct connected subnet /26'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Direct connected подсеть /26',
      en: 'Direct connected subnet /26'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Direct connected подсеть /27',
      en: 'Direct connected subnet /27'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Direct connected подсеть /27',
      en: 'Direct connected subnet /27'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Direct connected подсеть /27',
      en: 'Direct connected subnet /27'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Direct connected подсеть /27',
      en: 'Direct connected subnet /27'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Direct connected подсеть /27',
      en: 'Direct connected subnet /27'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Direct connected подсеть /27',
      en: 'Direct connected subnet /27'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Direct connected подсеть /28',
      en: 'Direct connected subnet /28'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Direct connected подсеть /28',
      en: 'Direct connected subnet /28'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Direct connected подсеть /28',
      en: 'Direct connected subnet /28'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Direct connected подсеть /28',
      en: 'Direct connected subnet /28'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Direct connected подсеть /28',
      en: 'Direct connected subnet /28'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Direct connected подсеть /28',
      en: 'Direct connected subnet /28'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Direct connected подсеть /29',
      en: 'Direct connected subnet /29'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Direct connected подсеть /29',
      en: 'Direct connected subnet /29'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Direct connected подсеть /29',
      en: 'Direct connected subnet /29'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Direct connected подсеть /29',
      en: 'Direct connected subnet /29'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Direct connected подсеть /29',
      en: 'Direct connected subnet /29'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Direct connected подсеть /29',
      en: 'Direct connected subnet /29'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Маршрутизируемый IP-адрес',
      en: 'Routed IP'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Маршрутизируемый IP-адрес',
      en: 'Routed IP'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Маршрутизируемый IP-адрес',
      en: 'Routed IP'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Маршрутизируемый IP-адрес',
      en: 'Routed IP'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Маршрутизируемый IP-адрес',
      en: 'Routed IP'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Маршрутизируемый IP-адрес',
      en: 'Routed IP'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Бэкапы одной виртуальной машины',
      en: 'Backup: Virtual machine'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Бэкапы одной виртуальной машины',
      en: 'Backup: Virtual machine'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Бэкапы одной виртуальной машины',
      en: 'Backup: Virtual machine'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Бэкапы одной виртуальной машины',
      en: 'Backup: Virtual machine'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Бэкапы одной виртуальной машины',
      en: 'Backup: Virtual machine'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Бэкапы одной виртуальной машины',
      en: 'Backup: Virtual machine'
    },
    oldPrices: {
      rub: 205.479,
      usd: 2.935,
      eur: 2.935
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Место в репозитории (за 1 ГБ)',
      en: 'Repository disk space (1 GB)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Место в репозитории (за 1 ГБ)',
      en: 'Repository disk space (1 GB)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Место в репозитории (за 1 ГБ)',
      en: 'Repository disk space (1 GB)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Место в репозитории (за 1 ГБ)',
      en: 'Repository disk space (1 GB)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Место в репозитории (за 1 ГБ)',
      en: 'Repository disk space (1 GB)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Место в репозитории (за 1 ГБ)',
      en: 'Repository disk space (1 GB)'
    },
    oldPrices: {
      rub: 0.420864,
      usd: 0.00601088,
      eur: 0.00601088
    }
  },
  {
    resource: 'windows_core',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: 'Windows Server (1 ядро)',
      en: 'Windows Server (1 core)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'windows_core',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: 'Windows Server (1 ядро)',
      en: 'Windows Server (1 core)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'windows_core',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: 'Windows Server (1 ядро)',
      en: 'Windows Server (1 core)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'windows_core',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: 'Windows Server (1 ядро)',
      en: 'Windows Server (1 core)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'windows_core',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: 'Windows Server (1 ядро)',
      en: 'Windows Server (1 core)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'windows_core',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: 'Windows Server (1 ядро)',
      en: 'Windows Server (1 core)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s_fe67_50k',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s_fe67_10k',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s_fe67_50k',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s_fe67_10k',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: '',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: 'eacbc41e-8809-4b6d-876a-84022924986a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: 'b5e425ce-a63e-4b98-96dc-ce7ff04572c9',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: 'a20baaef-4e9e-4686-9aee-231957268f95',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: '510a08cc-da48-4d98-b84b-b60d21f15b5b',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s_ec4d_2k',
    group: '91192387-5a7c-4d58-9721-b5f460f84cae',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_s_ec4d_2k',
    group: '2c895bd2-00a9-4e3b-b9d9-aca8918240cc',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'cpu_core',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: 'Процессорное ядро Platinum vCPU (3,1 ГГц в Москве)',
      en: 'Platinum vCPU (3,1 GHz in Moscow)'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'ram',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_fast_vssd',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_vssd',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'windows_core',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_32',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_29',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_28',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_26',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_large_ha',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad_ha',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_x_ha',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_cnt',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_prof',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_client_corp',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_std_2cpu',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_web_2cpu',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'vbr_backups_storage',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'storage_ultra_vssd',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: 'Ultra vSSD — 40 000 IOPS, Platinum пул, 1 ГБ',
      en: 'Ultra vSSD — 40 000 IOPS, Platinum Pool, 1 GB'
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_27',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_25',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'subnet_24',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_quad',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'edge_compact_ha',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'isolated_network',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_prof',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_1c_server_corp',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
    name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_sql_ent_2cpu',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    resource: 'license_rds_1user',
    group: 'f23f12dc-e993-41c6-afba-58ba43d31f8a',
     name: {
      ru: '',
      en: ''
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  }
]